import appConfig from '../../appConfig';

import {getAuthorizationHeaderWithBearer} from '../../common/network/apiUtils';

const ECOM_API_TIMEOUT = 300

function customerApiFactory(storefrontApiClient) {
  const customerApi = {
    getCustomerInfo(params) {
      return storefrontApiClient.get(`${appConfig.ecomApiUrl}/profile/audience`,
        {
          headers: {
            ...getAuthorizationHeaderWithBearer(params?.jwt)
          },
          timeout: ECOM_API_TIMEOUT,
        },
      );
    },
  };

  return customerApi;
}

export default customerApiFactory;
